import { TSubcategoryAction, SubcategoryActionTypes } from './subcategoryActions';
import { ISubcategoryState } from './subcategoryContext';

export const subcategoryReducer = (state: ISubcategoryState, action: TSubcategoryAction): ISubcategoryState => {
	switch (action.type) {
		case SubcategoryActionTypes.REFETCH_DATA:
			return {
				...state,
				needRefetchData: action.payload.needRefetchData,
			};
		case SubcategoryActionTypes.SET_SUBCATEGORIES_BY_CUSTOMER:
			return {
				...state,
				subcategoriesByCustomer: action.payload.subcategoriesByCustomer,
				typeOfModalWindow: action.payload.typeOfModalWindow,
				subcategoriesByRestaurant: { totalCount: 0, items: [] },
			};
		case SubcategoryActionTypes.SET_SUBCATEGORIES_BY_RESTAURANT:
			return {
				...state,
				subcategoriesByRestaurant: action.payload.subcategoriesByRestaurant,
				typeOfModalWindow: action.payload.typeOfModalWindow,
				subcategoriesByCustomer: { totalCount: 0, items: [] },
			};
		case SubcategoryActionTypes.CHANGE_SEARCH_STRING:
			return {
				...state,
				searchString: action.payload.searchString,
				currentPage: 1,
			};
		case SubcategoryActionTypes.TOGGLE_REMEMBER_MY_CHOICE:
			return {
				...state,
				rememberMyChoice: action.payload.rememberMyChoice,
			};
		case SubcategoryActionTypes.SET_ID_CUSTOMER:
			return {
				...state,
				IDSelectedCustomer: action.payload.IDSelectedCustomer,
				subcategoriesByCustomer: action.payload.subcategoriesByCustomer,
				subcategoriesByRestaurant: action.payload.subcategoriesByRestaurant,
				IDSelectedRestaurant: null,
				IDSelectedCategory: null,
				isHidden: false,
				currentPage: 1,
			};
		case SubcategoryActionTypes.SET_ID_RESTAURANT:
			return {
				...state,
				IDSelectedRestaurant: action.payload.IDSelectedRestaurant,
				isHidden: action.payload.isHidden,
				IDSelectedCategory: null,
				currentPage: 1,
			};
		case SubcategoryActionTypes.TOGGLE_IS_HIDDEN:
			return {
				...state,
				isHidden: !state.isHidden,
				currentPage: 1,
			};
		case SubcategoryActionTypes.SET_ID_CATEGORY:
			return {
				...state,
				IDSelectedCategory: action.payload.IDSelectedCategory,
				currentPage: 1,
			};
		case SubcategoryActionTypes.RESET_SELECTED_CONTROLS:
			return {
				...state,
				searchString: '',
				IDSelectedRestaurant: null,
				IDSelectedCategory: null,
				isHidden: false,
				currentPage: 1,
			};
		case SubcategoryActionTypes.SET_SORT_BY:
			return {
				...state,
				sortBy: action.payload.sortBy,
				currentPage: 1,
			};
		case SubcategoryActionTypes.SET_COUNT_OF_ITEMS:
			return {
				...state,
				countOfItems: action.payload.countOfItems,
				currentPage: 1,
			};
		case SubcategoryActionTypes.CHANGE_CURRENT_PAGE:
			return {
				...state,
				currentPage: action.payload.currentPage,
			};
		case SubcategoryActionTypes.SET_ID_FOR_DELETION:
			return {
				...state,
				IDForDeletion: action.payload.IDForDeletion,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case SubcategoryActionTypes.SET_ID_FOR_ASSIGN_RESTAURANTS:
			return {
				...state,
				IDForAssignRestaurants: action.payload.IDForAssignRestaurants,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case SubcategoryActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case SubcategoryActionTypes.SET_FILTERS_FROM_QUERY_STRING:
			return {
				...state,
				...action.payload.filters,
				isInitializedSelectCustomerModal: true,
			};
		default:
			return state;
	}
};
